import type { Company } from "../Company.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getCompanyUrlSlug } from "./getCompanyUrlSlug.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getClientDetailPath(tenant: Tenant, client: Pick<Partial<Company>, "name" | "urlSlug">): string {
	const pathMap = {
		[Locale.cs]: `/klient` as const,
	} satisfies LocalizedString;
	return `${getPathInLocale(tenant.locale, pathMap)}/${getCompanyUrlSlug(client)[tenant.locale]}`;
}
